import { render, staticRenderFns } from "./PeriodSelectbox.vue?vue&type=template&id=8f2ba074&"
import script from "./PeriodSelectbox.vue?vue&type=script&lang=js&"
export * from "./PeriodSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports